import { createSlice } from '@reduxjs/toolkit';
import extraReducers from './form.reducers';
import { initialState, ApiCredentialsFormState } from './apiCredentialsFormState';
import { RootState } from '../rootReducer';

const gettingStateUploadForm = (state: RootState): ApiCredentialsFormState => state.apiCredentials;

export const selectors = {
  gettingStateUploadForm
};

const apiCredentialsSlice = createSlice({
  name: 'apiCredentials',
  initialState,
  reducers: {},
  extraReducers: {
    ...extraReducers
  }
});

export const caseReducers = apiCredentialsSlice.caseReducers;
export default apiCredentialsSlice.reducer;